module.exports = __webpack_public_path__ + "img/savdo.2473002e.png";